import { render, staticRenderFns } from "./BlockFormPage.vue?vue&type=template&id=13ce58b0&scoped=true&"
import script from "./BlockFormPage.vue?vue&type=script&lang=ts&"
export * from "./BlockFormPage.vue?vue&type=script&lang=ts&"
import style0 from "./BlockFormPage.vue?vue&type=style&index=0&id=13ce58b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ce58b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VOverlay,VRow})
